import * as stream from 'getstream';
import sleep from './sleep';

enum Feed {
  UserUpdates = 'userUpdates',
}

interface FeedRequestOptions {
  withReactionCounts?: boolean;
  withRecentReactions?: boolean;
  withOwnReactions?: boolean;
  reactions?: {
    recent?: boolean;
    own?: boolean;
    counts?: boolean;
  };
  limit?: number;
  offset?: number;
  id_lt?: string;
  id_lte?: string;
  id_gt?: string;
  id_gte?: string;
  ranking?: string;
  mark_seen?: any;
  mark_read?: any;
  refresh?: boolean;
}

interface Activity {
  actor: string; // GIK user id
  id: string; // stream-generated id
  object: string; // our id
  verb: string; // eg. "userUpdate"
  time: string; // created date time
  foreign_id: string;
  origin: any;
  target: string;
}

export interface UserUpdateActivity extends Activity {
  userUpdate: {
    title: string;
    description: string;
    publishedDate: string;
  };
  userUpdateStatic: {
    organiserId: string;
    organiserFullName: string;
    pageRouteId: string;
  };
  userUpdateMedia: { [key: string]: any }; // fixme InkindUserUpdateMedia
  userUpdateDeleted?: boolean;
}

interface GetActivitiesResponse<T extends Activity> {
  results: Array<T>;
  next: string;
}

interface FeedResponse<T extends Activity> extends GetActivitiesResponse<T> {}

export interface UserUpdatesFeedResponse extends FeedResponse<UserUpdateActivity> {}

export default class StreamClient {
  private static _client: stream.StreamClient;

  static init(streamApiKey: string, userToken: string, streamAppId: string) {
    if (this._client) {
      return;
    }
    this._client = stream.connect(streamApiKey, userToken, streamAppId);
  }

  static async getUserUpdates(pageRouteId: string): Promise<UserUpdatesFeedResponse> {
    // FIXME: find a better way of ensuring stream is loaded,
    // maybe return StreamClient in useStream hook after it is loaded, and don't access StreamClient directly here
    while (!this._client) {
      await sleep(100);
    }
    const feed = this._client.feed(Feed.UserUpdates, pageRouteId);
    // FIXME remove `as unknown`
    return (feed.get(({ limit: 99 } as unknown) as FeedRequestOptions) as unknown) as Promise<UserUpdatesFeedResponse>;
  }

  static async getUserUpdate(userUpdateId: string): Promise<UserUpdateActivity> {
    // FIXME remove `as unknown`
    const response = ((await this._client.getActivities({
      ids: [userUpdateId],
    })) as unknown) as GetActivitiesResponse<UserUpdateActivity>;
    return response.results[0];
  }
}
